const FormatMoney = (value) => {
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
}

(($) => {
  const ProductDescription = () => {
    // Show toggle if description height > facts height
    $('.custom_product_desk').each((index, target) => {
      let $description = $(target);
      let description_ht = $description.height();
      //let description_ht = GetElementHeight(target);
      let $section = $description.closest('.image-with-text');
      let offset = 100;
      let $facts = $section.find('.supplement-facts-table');
      let facts_table_ht = $facts.height();

      if (description_ht > facts_table_ht) {
        let max_ht = facts_table_ht - offset;
        if (max_ht < 310) max_ht = 310;
        $description.data('height', `${ description_ht }px`);
        $description.data('max-height', `${ max_ht }px`);
        $description.css({
          'max-height': `${ max_ht }px`
        });
        $section.find('.deskshowalltable').removeClass('hidden');
      }
    });

    // toggle description and animate height
    $(document).on('click', '.deskshowalltable', (e) => {
      e.preventDefault();
      let $target = $(e.currentTarget);
      $target.toggleClass("active");
      let $description = $('.custom_product_desk');
      let description_ht = $description.data('height');
      let max_ht = $description.data('max-height');

      if($target.hasClass('active')) {
        $description.animate({ "max-height": description_ht }, 500);
      }
      else{
        $description.animate({ "max-height": max_ht }, 500);
      }
    });
  }

  /**
  *   Order Variants by Count
  *   - orders the third variant option
  */
  (function orderVariantsByCount() {
    let variantOptions      = document.querySelectorAll('[data-variant-option-index="2"] .options-selection__option-value');
    let variantOptionValues = [];

    if (!variantOptions) return;

    // loop over otions
    variantOptions.forEach(option => variantOptionValues.push(option.getAttribute('data-value').replace(/\D/g, '')));
    variantOptionValues = variantOptionValues.sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));

    if (!variantOptionValues) return;

    variantOptionValues.forEach((value, index) => {
      variantOptions.forEach(option => {
        let currentValue = option.getAttribute('data-value').replace(/\D/g, '');
        let arrayValue = value.replace(/\D/g, '');

        if (currentValue == arrayValue) {
          option.style.order = index;
        }
      });
    });
  })();


  (function initCJScript() {
    const targetUrl = "/apps/pricefy-widget/get-price-info";

    // Function to load the CJ script
    const loadCJScript = () => {
        let old_script_tag = document.querySelector('script[src="https://www.anrdoezrs.net/am/101155289/include/allCj/generate/onLoad/impressions/page/am.js"]');

        if (old_script_tag) old_script_tag.remove();

        let dj_script_tag  = document.createElement('script');
        dj_script_tag.type = 'text/javascript';
        dj_script_tag.src  = 'https://www.anrdoezrs.net/am/101155289/include/allCj/generate/onLoad/impressions/page/am.js';

        document.body.appendChild(dj_script_tag);
    };

    // Override the global fetch function
    const originalFetch = window.fetch;
    window.fetch = async function (...args) {
        const [resource, config] = args;

        // Check if the request URL contains the base path
        if (typeof resource === 'string' && resource.includes(targetUrl)) {
            // console.log("Detected fetch request to Pricefy URL:", resource);

            try {
                const response = await originalFetch(...args);
                if (response.ok) {
                    const data = await response.clone().json();

                    // console.log("Pricefy data received:", data);

                    // Load the CJ script after detecting a successful fetch
                    loadCJScript();
                }
                return response;
            } catch (error) {
                console.error("Error in intercepted fetch request:", error);
                throw error;
            }
        } else {
            // For non-target URLs, proceed with the original fetch function
            return originalFetch(...args);
        }
    };
  })();


  const FormatMoney = (value) => {
    return value.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  }

  const VariantChange = () => {
    let product;
    let SetProduct = (_product) => {
      product = _product;
    }

    let UpdateVariantSwatchPrices = ($product) => {
      if (!$product) return;

      let product = $product.data('product');

      if (!product) return;

      product.options_with_values = $product.data('options_with_values');

      let selected_options = [...$product.find('input:checked')].map(item => item.value);

      let lastOptionIndex = product.options_with_values.length;
      let lastOptionIndex0 = lastOptionIndex - 1;

      product.options_with_values[lastOptionIndex0].values.forEach((value) => {
        let options_to_match = [...selected_options];
        options_to_match[lastOptionIndex0] = value;
        let value_variant = product.variants.find((v) => v.options.join('/') == options_to_match.join('/'));
        let $option = $product.find(`[data-variant-option-index="${ lastOptionIndex0 }"]`).find(`[data-value="${ value }"]`);
        if (value_variant) {
          $option.find('.variant-price').text(FormatMoney(value_variant.price / 100));
        }
      });
    }

    UpdateVariantParts = () => {
      document.addEventListener('variant-change', async (e) => {
        let product = e.detail.product;
        let variant = e.detail.variant;
        let state = e.detail.state;
        product.selected_variant = variant;
        product.state = state;
        SetProduct(product);

        if (e.detail.state == 'selected') {
          // fix for quickshop modal
          // use variant id from selected variant instead of url
          let product_url = `${window.location.origin}${product.url}?variant=${variant.id}&view=raw-variant-parts`;
          let html = await $.get(product_url);
          let $html = $(html);

          // update variant price per unit
          let $price_per_unit = $html.filter('.customgran_p')[0];

          if ($price_per_unit) $('.customgran_p').html($price_per_unit.innerHTML);
        }


        if (typeof PRODUCT_DATA !== 'undefined' && variant) {
          // Variant Custom Grad
          let variant_data = PRODUCT_DATA.variants.find(v => v.id == variant.id);

          if (variant_data.custom_grad_details.details) {
            $('.custom_grad .details').html(variant_data.custom_grad_details.details);

            $('.custom_grad .tooltip-inner').attr('style', function (i, style) {
              return style && style.replace(/display[^;]+;?/g, '');
            });

          } else if (variant_data.custom_grad_details.details == '') {
            $('.custom_grad .details').html('');
            $('.custom_grad .tooltip-inner').css({ display: 'none' });
          }

          if (variant_data.custom_grad_details.tag_img_url) {
            $('.custom_grad img').attr('src', variant_data.custom_grad_details.tag_img_url);
          }

          // Variant supplement facts
          if (variant_data.supplement_facts) {
            $('.supplement-facts-wrap').html(variant_data.supplement_facts);
          }

          if (variant_data.description) {
            $('[data-variant-description]').html(variant_data.description);
          }

          // set section min-height
          const chartSection = document.querySelector('.section-video-with-chart');

          let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

          if (!isMobile && chartSection) {
            let supplementFactsSection = chartSection.nextSibling;

            if (supplementFactsSection && supplementFactsSection.classList.contains('supplement-facts-table--section')) {
              supplementFactsSection.style.minHeight = chartSection.offsetHeight;

              $(supplementFactsSection).css({ minHeight: chartSection.offsetHeight });
            }
          }
        }


        // change video
        const dynamicVideoScripts = document.querySelectorAll('[data-section-type="dynamic-video"]');
        const variantId           = variant.id;

        if (dynamicVideoScripts) {

          function youtube_parser(url) {
            var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
            var match = url.match(regExp);
            return (match && match[7].length == 11) ? match[7] : false;
          }

          dynamicVideoScripts.forEach(videoScript => {
            const data          = JSON.parse(videoScript.innerHTML);
            const videos        = data.variant_youtube_videos;
            let defaultVideoUrl = data.default_variant_video;
            let defaultVideoId  = youtube_parser(defaultVideoUrl);
            let videoId         = null;

            if (!videos) return;

            videos.forEach(video => {
              if (variantId == video.id) {
                videoId = youtube_parser(video.url)
              }
            });

            if (!videoId) videoId = defaultVideoId;

            if (videoId) {
              const container = videoScript.parentElement;
              const iframe    = container.querySelector('.dynamic-video .youtube iframe');

              if (!iframe) return;

              let iframeSrc   = iframe.src;

              iframeSrc       = iframeSrc.replace(/embed\/.*\?/, `embed/${videoId}?`)
              iframe.src      = iframeSrc;
            }
          });
        }
      });
    }

    $(document).on('change', '.options-selection__option-values input[type=radio]', (e) => {
      let $target = $(e.currentTarget);
      let $form = $target.closest('[data-product-form]');
      let option_index = $target.data('variant-option-value-index');
      let selected_value = $target.val();

      let $product = $target.closest('.product-form--regular');
      UpdateVariantSwatchPrices($product);

      let option1Radios = $form[0].querySelectorAll('input[data-variant-option-value-index="0"]');
      let option2Radios = $form[0].querySelectorAll('input[data-variant-option-value-index="1"]');
      let option3Radios = $form[0].querySelectorAll('input[data-variant-option-value-index="2"]');

      let optionKey = `option${option_index + 1}`;

      let option1Checked = null;
      let option2Checked = null;
      let option3Checked = null;

      option1Radios.forEach(input => {
        if (input.checked) option1Checked = input.value;
      });

      option2Radios.forEach(input => {
        if (input.checked) option2Checked = input.value;
      });

      option3Radios.forEach(input => {
        if (input.checked) option3Checked = input.value;
      });


      // get closest available option
      if (product?.state == 'unavailable') {
        let matchingPairs = [];

        // if first option is clicked
        if (optionKey == 'option1') {
          // get matches for the selected
          product.variants.forEach(v => {
            if (v['option1'] == selected_value) {
              updateForm(v);
            }
          });

          // second option clicked
        } else if (optionKey == 'option2') {

          // get matches for the selected
          product.variants.forEach(v => {
            if (v['option2'] == selected_value) {
              matchingPairs.push(v);
            }
          });

          let match = matchingPairs[0];

          matchingPairs.forEach(p => {
            if (p.option1 == option1Checked && p.option2 == option2Checked && p.option3 == option3Checked) {
              // update if better match
              match = p;
            }
          });

          updateForm(match);

          // third option clicked
        } else if (optionKey == 'option3') {

          // get matches for the selected
          product.variants.forEach(v => {
            if (v['option3'] == selected_value) {
              matchingPairs.push(v);
            }
          });

          let match = matchingPairs[0];

          matchingPairs.forEach(p => {
            if (p.option1 == option1Checked && p.option2 == option2Checked) {
              match = p;
            }
          });

          updateForm(match);
        }
      }


      function updateForm(variant) {
        let input;

        const { option1, option2, option3 } = variant

        // clear previous selections
        $form.find('input[type=radio]').each((input) => {
          input.checked = false;
        });

        if (option1) {
          let $input = $form.find(`input[value="${option1}"]`);
          $input.prop('checked', true);

          input = $input;
        }

        if (option2) {
          let $input = $form.find(`input[value="${option2}"]`);
          $input.prop('checked', true);

          input = $input;
        }

        if (option3) {
          let $input = $form.find(`input[value="${option3}"]`);
          $input.prop('checked', true);

          input = $input;
        }

        input[0].dispatchEvent(new Event('change'));
        UpdateVariantSwatchPrices($product);
      }

      // double check which options are selected and set their availability
      changeVariantAvailability($form[0], product);

    });


    // also run on page load
    UpdateVariantParts();
    let $product = $('.product-form--regular');
    UpdateVariantSwatchPrices($product);

    let uProduct = $product.data('product');
    let $form = $('[data-product-form]');

    if ($form && $form[0]) {
      let option1Radios = $form[0].querySelectorAll('input[data-variant-option-value-index="0"]');
      let option2Radios = $form[0].querySelectorAll('input[data-variant-option-value-index="1"]');
      let option3Radios = $form[0].querySelectorAll('input[data-variant-option-value-index="2"]');

      let matchingPairs = [];

      let option1Checked = null;
      let option2Checked = null;
      let option3Checked = null;

      option1Radios.forEach(input => {
        if (input.checked) option1Checked = input.value;
      });

      option2Radios.forEach(input => {
        if (input.checked) option2Checked = input.value;
      });

      option3Radios.forEach(input => {
        if (input.checked) option3Checked = input.value;
      });


      // loop over variants
      // get varaints with first option
      uProduct.variants.forEach(v => {
        if (v.option1 == option1Checked) {
          matchingPairs.push(v);
        }
      })

      if (option2Radios) {
        option2Radios.forEach(input => {
          let isAvailable = false;

          matchingPairs.forEach(p => {
            if (p.option2 == input.value) isAvailable = true;
          })

          isAvailable
            ? input.setAttribute('data-variant-availability', 'available')
            : input.setAttribute('data-variant-availability', 'unavailable')
        });
      }

      if (option3Radios) {
        option3Radios.forEach(input => {
          let isAvailable = false;

          matchingPairs.forEach(p => {
            if (p.option1 == option1Checked && p.option2 == option2Checked && p.option3 == input.value) {
              isAvailable = true;
            }
          })


          isAvailable
            ? input.setAttribute('data-variant-availability', 'available')
            : input.setAttribute('data-variant-availability', 'unavailable')

          if (!isAvailable) {
            console.log(input.parentElement.querySelector('.variant-price'));
          }
        });
      }
    }
  }

  const DOMReady = () => {
    ProductDescription();
    VariantChange();
  }

  $(document).ready(DOMReady);
})(jQuery);



function changeVariantAvailability(form, product) {
  let option1Radios = form.querySelectorAll('input[data-variant-option-value-index="0"]');
  let option2Radios = form.querySelectorAll('input[data-variant-option-value-index="1"]');
  let option3Radios = form.querySelectorAll('input[data-variant-option-value-index="2"]');

  let matchingPairs = [];

  let option1Checked = null;
  let option2Checked = null;
  let option3Checked = null;

  option1Radios.forEach(input => {
    if (input.checked) option1Checked = input.value;
  });

  option2Radios.forEach(input => {
    if (input.checked) option2Checked = input.value;
  });

  option3Radios.forEach(input => {
    if (input.checked) option3Checked = input.value;
  });


  // loop over variants
  // set available variants on page load
  product.variants.forEach(v => {
    if (v.option1 == option1Checked) {
      matchingPairs.push(v);
    }
  })

  if (option2Radios) {
    option2Radios.forEach(input => {
      let isAvailable = false;

      matchingPairs.forEach(p => {
        if (p.option2 == input.value) isAvailable = true;
      })

      isAvailable
        ? input.setAttribute('data-variant-availability', 'available')
        : input.setAttribute('data-variant-availability', 'unavailable')
    });
  }

  if (option3Radios) {
    option3Radios.forEach(input => {
      let isAvailable = false;

      matchingPairs.forEach(p => {
        if (p.option1 == option1Checked && p.option2 == option2Checked && p.option3 == input.value) {
          isAvailable = true;
        }
      })

      isAvailable
        ? input.setAttribute('data-variant-availability', 'available')
        : input.setAttribute('data-variant-availability', 'unavailable')


      if (!isAvailable) {
        input.parentElement.querySelector('.variant-price').innerHTML = '--';
      }
    });
  }
}


document.addEventListener('quickshop:loaded', function (event) {
  const { productId, variantId, modal } = event.detail;
  let form = modal.$modal[0].querySelector('[data-product-form]');

  changeVariantAvailability(form, event.detail.product);

  let $product = $('.product-form--regular');
  let product = $product.data('product');

  if (!product) return;

  product.options_with_values = $product.data('options_with_values');

  let selected_options = [...$product.find('input:checked')].map(item => item.value);

  let lastOptionIndex = product.options_with_values.length;
  let lastOptionIndex0 = lastOptionIndex - 1;

  product.options_with_values[lastOptionIndex0].values.forEach((value) => {
    let options_to_match = [...selected_options];
    options_to_match[lastOptionIndex0] = value;
    let value_variant = product.variants.find((v) => v.options.join('/') == options_to_match.join('/'));
    let $option = $product.find(`[data-variant-option-index="${lastOptionIndex0}"]`).find(`[data-value="${value}"]`);
    if (value_variant) {
      $option.find('.variant-price').text(FormatMoney(value_variant.price / 100));
    }
  });
});


function replaceUrlParam(url, paramName, paramValue) {
  if (paramValue == null) {
    paramValue = '';
  }
  var pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
  if (url.search(pattern) >= 0) {
    return url.replace(pattern, '$1' + paramValue + '$2');
  }
  url = url.replace(/[?#]$/, '');
  return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
}


let groups = document.querySelectorAll('li.group');

if (groups) {
  groups.forEach(group => {
    let listItems = group.querySelectorAll('li');

    if (listItems?.length <= 2) {
      group.classList.add('group--break');
    }
  });
}